import { FC, SVGProps } from 'react'

export const YDShovel: FC<SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 32,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}>
    <path
      d="M4.4155282,9.02772277 C2.21262391,6.71735974 1.55321797,3.42521452 1.92932358,0.333333333 C4.83070972,0.435907591 7.74186484,0.387062706 10.6481355,0.372409241 C10.9851652,3.47405941 10.4625249,6.76620462 8.19123777,9.07168317 C8.16681533,12.3931353 8.21077573,15.709703 8.16193084,19.0262706 C9.38793744,19.0555776 10.6090596,19.0848845 11.8350662,19.089769 C11.903449,22.030231 12.0890596,25.1660726 10.433218,27.759736 C9.4074754,29.8112211 6.88219487,31.9408581 4.57671632,30.3973597 C0.991501799,27.9160396 0.45420807,23.1243564 0.727739423,19.1141914 C1.963515,19.0946535 3.19929058,19.060462 4.43995064,19.0262706 C4.39599025,15.6950495 4.43018167,12.3589439 4.4155282,9.02772277 Z M6.44259091,7.40607261 C7.52694734,6.09214521 8.25473612,4.52910891 8.39638629,2.81465347 C7.02384503,2.80976898 5.65618827,2.80488449 4.2885315,2.8 C4.33737639,4.57306931 5.07493414,6.25821782 6.44259091,7.40607261 Z"
      className="fill-yellow-500"></path>
  </svg>
)
